import { render, staticRenderFns } from "./TemplatesCollectionPublic.vue?vue&type=template&id=85189180&"
import script from "./TemplatesCollectionPublic.vue?vue&type=script&lang=ts&"
export * from "./TemplatesCollectionPublic.vue?vue&type=script&lang=ts&"
import style0 from "./TemplatesCollectionPublic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports